/**
 * @generated SignedSource<<f396cd4d6a82e77f08409973d9254fd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoScheduleQuery$variables = {
  workspaceTodoId: string;
};
export type WorkspaceTodoScheduleQuery$data = {
  readonly todoWorkspace: {
    readonly expireAtDate: {
      readonly isoString: string;
    } | null;
    readonly id: string;
    readonly receiverStores: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly updatedAtDate: {
      readonly isoString: string;
      readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
    } | null;
  };
};
export type WorkspaceTodoScheduleQuery = {
  response: WorkspaceTodoScheduleQuery$data;
  variables: WorkspaceTodoScheduleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceTodoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceTodoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UnzonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoScheduleQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "TodoWorkspace",
          "kind": "LinkedField",
          "name": "todoWorkspace",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UnzonedDate",
              "kind": "LinkedField",
              "name": "updatedAtDate",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FormattedDate"
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "updatedAtDate",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5489ebfec74bfc21a453a25cf703ef19",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoScheduleQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodoScheduleQuery(\n  $workspaceTodoId: ID!\n) {\n  todoWorkspace(id: $workspaceTodoId) {\n    id\n    updatedAtDate {\n      ...FormattedDate\n      isoString\n    }\n    receiverStores {\n      id\n    }\n    expireAtDate {\n      isoString\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "fb885073a3c780fd2014cbff2b54590a";

export default node;
